/// <summary>
/// SDK常量
/// </summary>
/// <author>xiexingwu</author>
export const KitConst =
    {
        //SDK版本号
        KIT_VERSION_CODE: 1,
        // KIT_VERSION_NAME  : `${KIT_VERSION_CODE}.4.2`,
        KIT_VERSION_NAME: "1.4.2",
        BASEMENT_TYPE: "h5_wj_kit",

        UUID: "uuid",
        PACKAGE_NAME: "package_name",
        OS_LANGUAGE: "os_language",
        COUNTRY: "country",
        DPI: "dpi",
        SCREEN_HEIGHT: "screen_height",
        SCREEN_WIDTH: "screen_width",
        VERSION_NAME: "version_name",
        VERSION_CODE: "version_code",
        OS_VERSION: "os_version",
        OS: "os",
        PHONE_MODEL: "phone_model",
        IMSI: "imsi",
        IMEI: "imei",
        ANDROID_ID: "android_id",
        IDFV: "idfv",
        GOOGLE_AID: "google_aid",
        IS_UPGRADE_USER: "is_upgrade_user",
        NET: "net",
        INSTALL_DAYS: "install_days",
        INSTALL_HOURS: "install_hours",
        PRODUCT_ID: "product_id",
        RELEASE_PRODUCT_ID: "release_product_id",
        CHANNEL: "channel",
        MEDIA_SOURCE: "media_source",
        CAMPAIGN: "campaign",
        ADSET: "adset",
        ADGROUP: "adgroup",
        AB_TEST: "ab_test",
        USR_ABS: "usr_abs",
        TP_DEVICE_ID: "tp_device_id",
        H5_HOST_NAME: "h5_host_name",
        header_str: "header_str",

        NET_TYPE_UNKNOWN: "unknown",
        //wifi网络
        NET_TYPE_WIFI: "wifi",
        //2G网络
        NET_TYPE_2G: "2g",
        //3G网络
        NET_TYPE_3G: "3g",
        //4G网络
        NET_TYPE_4G: "4g",
        //其他网络,如热点、代理、以太网等.
        NET_TYPE_OTHER: "other",

        gameFun: "gameFun",
        abtest: "abtest",
        userBuy: "userBuy",
        user_id: "user_id",
        uuid: "uuid",
        actvite_time: "actvite_time",
        android: "android",
        IOS: "ios",
        WEB: "web",
        adid: "adid",
        idfv: "idfv",
        IFA: "ifa",

        unitylog: "unitylog",
        log: "log",

        URL: "url",
        // testConfig: "{\"log\":true,\"testmode\":true,\"adtest\":true,\"unitylog\":true,\"test210\":true}",
    }
